import React from 'react'
import styled from 'styled-components'

import logo from '../assets/footer-logo.png'

const FooterDiv = styled.div`
  color: #666666;
`
const Footer = () => <div className="container-fluid border-top">
  <div className="container">
    <div className="row align-items-center justify-content-between" style={{minHeight: '100px'}}>
      <FooterDiv className="col-5 col-md-1 order-md-3 text-left text-md-right">
        <a href="//aleph.vc"  rel="noopener noreferrer" target="_blank" className="text-muted">Aleph.vc</a>
      </FooterDiv>
      <FooterDiv className="col-7 col-md-4 order-md-3 col-lg-2 text-right text-md-right text-nowrap">
        <a href="//bit.ly/subscribe-aleph-newsletter-jobs"  rel="noopener noreferrer" target="_blank" className="text-muted pl-3">Join Aleph Newsletter</a>
      </FooterDiv>
      <div className="col order-2"></div>
      <FooterDiv className="col-5 col-md-2 order-md-1">
        <img src={logo} alt="Aleph VC" height={25}/>
      </FooterDiv>
      <FooterDiv className="col-7 col-md-3 order-md-1 text-nowrap text-right text-md-left">
          &copy; {(new Date()).getFullYear()} All rights reserved.
      </FooterDiv>
    </div>
  </div>
</div>
export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js